<template>
    <div>
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>

        <div class="alert alert-success" v-if="markedComplete">
            The risk audit has been marked as complete successfully.
        </div>

        <div class="risk-audit-container" v-if="!markedComplete">

            <div class="mb-5 entity-row-1">

                <div class="row border pt-3 pb-3">
                    <div class="col-md-8">
                        <p><strong class="search-title" data-container="entity-row-1">
                            <router-link :to="{ name: 'risk-audit-edit', params: {id: riskAudit.site_risk_audit_id} }">
                                {{ riskAudit.ra_cover.reference_number === null && riskAudit.ra_cover.prepared_for === null ? riskAudit.site_risk_audit_id : riskAudit.ra_cover.reference_number + ' | ' + riskAudit.ra_cover.prepared_for }}
                            </router-link>
                        </strong><br>
                        <small>version: <span v-if="riskAudit.report_version">{{ riskAudit.report_version }}</span><span v-else>NO VERSION</span></small>
                        </p>
                    </div>
                </div>

                <div class="row border-top pt-4 pb-4 bg-grey">

                    <div class="col-md-3 mb-2">
                        <router-link :to="{ name: 'risk-audit-edit', params: {id: riskAudit.site_risk_audit_id} }"  class="btn btn-md btn-square btn-outline-secondary w-100">
                            Edit
                        </router-link>
                    </div>

                    <div class="col-md-3 mb-2">
                        <button
                                v-on:click="markRiskAuditComplete"
                                ref="markRiskAuditCompleteButton"
                                class="btn btn-md btn-square btn-outline-success w-100"
                                v-bind:data-report-id="riskAudit.site_risk_audit_id"
                                style="margin: 0 5px;"
                        >Mark Complete</button>

                    </div>

                    <!--
                    <div class="col-md-3 mb-2">
                        <a class="btn btn-md btn-square btn-outline-dark w-100" v-if="navigatorOnline"
                           v-on:click="exportReport"
                           ref="exportReportButton"
                           target="_blank"
                           v-bind:data-report-id="riskAudit.site_risk_audit_id"
                           style="margin: 0 5px;">
                            Export </a>

                        <a class="btn btn-md btn-square btn-outline-dark w-100 btn-disabled" v-else
                           style="margin: 0 5px;">
                            <img class="img-fluid" src="/img/offline.png" style="width: 20px; margin-right: 10px;" v-if="!navigatorOnline"> Sync required </a>
                    </div>
                    -->

                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        props: ['riskAudit'],
        components: {
            Loading
        },
        computed: {
            navigatorOnline() {
                return navigator.onLine;
            }
        },
        data() {
            return {
                isLoading: false,
                markedComplete: false,
            }
        },
        methods: {
            exportReport() {
                this.isLoading = true;
                var button = this.$refs.exportReportButton;
                var reportId = button.dataset.reportId;
                axios.get(this.cmsUrl + 'api/v1/risk-audits/export/'+reportId+'.json', {headers: {'Authorization': 'Bearer '+this.$session.get('user_token')}})
                    .then(response => {
                        this.isLoading = false;
                        if (response.data.status) {
                            var ua = window.navigator.userAgent;
                            if(!!ua.match(/iPad/i) || !!ua.match(/iPhone/i)) {
                                window.location.href = response.data.pdf_url;
                            } else {
                                window.open(response.data.pdf_url, '_blank');
                            }
                        } else {
                            this.$swal('Sorry', response.data.message, 'info')
                        }
                    }).catch(error => {
                    this.isLoading = false;
                    this.$swal('Sorry', 'There was a problem. Please try again.', 'info')
                });
            },
            markRiskAuditComplete() {
                var vm = this;
                this.getDb(function onConnected(db) {
                    var button = vm.$refs.markRiskAuditCompleteButton;
                    var reportId = button.dataset.reportId;
                    console.log(reportId);

                    try {
                        var report = parseInt(reportId);
                        console.log('report ID', reportId)
                        var objectStore = db.transaction('risk_assessments').objectStore('risk_assessments');
                        var storeRequest = objectStore.get(report);

                        var vmt = vm;
                        storeRequest.onsuccess = function(event) {
                            vmt.riskAudit = storeRequest.result;
                            console.log(vmt.riskAudit);
                            vmt.riskAudit.is_complete = true;
                            vmt.riskAudit.status_changed = true;

                            vmt.$swal({
                                title: 'Are you sure?',
                                text: 'Are you sure you want to mark this report as complete?',
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#DD6B55',
                                confirmButtonText: 'Yes',
                                closeOnConfirm: false,
                                showLoaderOnConfirm: true,
                                buttons: {
                                    cancel: {
                                        text: 'Cancel',
                                        value: null,
                                        visible: false,
                                        className: 'btn btn-square btn-sm btn-secondary',
                                        closeModal: true,
                                    },
                                    confirm: {
                                        text: 'Yes',
                                        value: true,
                                        visible: true,
                                        className: 'btn btn-square btn-sm btn-primary',
                                        closeModal: true
                                    }
                                }
                            }).then((result) => {
                                if (result.value) {

                                    var putRequest = db.transaction('risk_assessments', 'readwrite')
                                        .objectStore('risk_assessments').put(vmt.riskAudit);
                                    putRequest.onsuccess = function (event) {
                                        vmt.markedComplete = true;
                                    };
                                    putRequest.onerror = function (event) {
                                        console.log(event);
                                    };

                                }
                            });
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            }
        }
    }
</script>